import React from 'react';


class SmallQuote extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'SmallQuote';

    // bind functions to component
    this.renderDescription = this.renderDescription.bind(this);
  }


  /**
   * Renders quotes description
   * @returns {ReactElement} - A ReactElement
   */
  renderDescription() {
    const data = this.props.data;
    let element;

    if (data.description) {
      element = (
        <div className='description'>{data.description}</div>
      );
    }

    return element;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const description = this.renderDescription();
    const data = this.props.data;
    const descriptionClass = data.description ? ' has-description' : '';
    const className = 'component-small-quote ' +
      data.direction +
      descriptionClass;
    const quoteStyle = {
      backgroundColor: data.bgColor,
      height: this.props.height,
    };
    const pointerInnerStyle = {
      borderColor: data.bgColor + ' transparent transparent transparent',
    };

    if (this.props.position === 'bottom') {
      quoteStyle.position = 'absolute';
      quoteStyle.bottom = '0';
    }

    return (
      <div
        className={className}
        style={quoteStyle}
      >
        {description}
        <div
          className='text'
          dangerouslySetInnerHTML={{ __html: data.text }}
        />
        <div className='pointer'>
          <div
            className='inner'
            style={pointerInnerStyle}
          />
        </div>
        <div className='speaker-image'>
          <img src={data.speakerImage} alt='Bleacher Report' />
        </div>
      </div>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} height - A height for the card
 * @prop {String} position - A position for the quote, can be 'top' or 'bottom'
 */
SmallQuote.propTypes = {
  data: React.PropTypes.object.isRequired,
  height: React.PropTypes.number,
  position: React.PropTypes.string,
};


export default SmallQuote;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallQuote.jsx
 **/